import moment from 'moment';

const SECTIONS_LOCAL_STORAGE = 'SECTIONS_LOCAL_STORAGE';
export const getSectionsFromLocalStorage = () => {
  const sections = localStorage.getItem(SECTIONS_LOCAL_STORAGE);
  return sections ? JSON.parse(sections) : undefined;
};

export const setSectionsInLocalStorage = sections => {
  localStorage.setItem(SECTIONS_LOCAL_STORAGE, JSON.stringify(sections));
};

// const QUESTIONS_LOCAL_STORAGE = 'QUESTIONS_LOCAL_STORAGE';
// export const getQuestionsFromLocalStorage = () => {
//   const questions = localStorage.getItem(QUESTIONS_LOCAL_STORAGE);
//   return questions ? JSON.parse(questions) : undefined;
// }

// export const setQuestionsInLocalStorage = (questions) => {
//   localStorage.setItem(QUESTIONS_LOCAL_STORAGE, JSON.stringify(questions));
// }

const checkHidden = (answer, val) => {
  return (
    answer?.answerValidations?.filter(
      av => av.validationId === val.dbId && av.hidden,
    ).length > 0
  );
};

export const noPeriodText = 'No period selected';
export const getYearFromRow = row =>
  row ? row.year || row.period || noPeriodText : noPeriodText;

export const validate = (qId, answer, validations, sectionAnswers) => {
  let errorOrWarning;
  validations?.[qId]?.forEach(val => {
    if (checkHidden(answer, val)) return;
    switch (val.validation) {
      case 'no_input_text':
        if (!answer.text || answer.text === '') {
          errorOrWarning = {
            type: val.validationType,
            text: val.text,
            id: val.dbId,
          };
        }
        break;
      case 'no_selection':
        if (!answer.text || answer.text === '') {
          errorOrWarning = {
            type: val.validationType,
            text: val.text,
            id: val.dbId,
          };
        }
        break;
      case 'dates_more_than_year': {
        const continuousDate =
          sectionAnswers
            .find(x => x.questionId === 10002)
            ?.text?.startsWith('Continuously') || false;
        if (answer.date1 && answer.date2 && !continuousDate) {
          const start = moment(answer.date1, 'YYYY-MM-DD');
          const end = moment(answer.date2, 'YYYY-MM-DD');
          if (end.diff(start, 'years', true) > 1) {
            errorOrWarning = {
              type: val.validationType,
              text: val.text,
              id: val.dbId,
            };
          }
        }
        break;
      }
      case 'date_end_before_start':
        if (answer.date1 && answer.date2) {
          const start = moment(answer.date1, 'YYYY-MM-DD');
          const end = moment(answer.date2, 'YYYY-MM-DD');
          if (end.isBefore(start)) {
            errorOrWarning = {
              type: val.validationType,
              text: val.text,
              id: val.dbId,
            };
          }
        }
        break;
      default:
        break;
    }
  });
  return errorOrWarning;
};
